<template>
    <HelpListPage
        id="HELP_PAGE_CADASTRAL_INFO"
        :heading="$t('helpPage.cadastralPage.heading')"
        :title="$t('helpPage.cadastralPage.title')"
        :description="$t('helpPage.cadastralPage.description')"
    />
</template>

<script>
import HelpListPage from '../../components/help/helpListPage';
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'

export default {
    components: {
        HelpListPage
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    }
}
</script>
